import MoreVertIcon from "@mui/icons-material/MoreVert";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import "./HomeCard.css";
import { colors } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const HomeCard = ({ title, img, data ,handleCardClick={}, desc="",id=""}) => {
    const navigate = useNavigate();
    const {t} = useTranslation('global');

    return (
        <div className="featured" style={{
            background: 'white',
            margin: 20,
            borderRadius: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '200px', // Set a minimum height for the card
            width: '150px', // Set a fixed width if necessary
        }}>
            <div className="top" style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%'
            }}>
                {/* <h3 className="title">{title}</h3> */}
            </div>
            <div className="bottom" style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center'
            }}>
                <div className="featuredChart" style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',

                }} >
                    <img src={img} alt="image" style={{ height: 120, width: 120, }} />
                </div>
                <p style={{ fontSize:14 }}> {desc}</p>
                {title === "Education" && <p style={{ fontSize:13 }}> {t('audioClip')}</p>}


                <p
                    className="title"
                    style={{
                        display: 'inline-block',
                        padding: '0.5rem 0.5rem',
                        border: '2px solid #015681',
                        borderRadius: '4px',
                        backgroundColor: 'transparent',
                        color: '#015681',
                        textAlign: 'center',
                        cursor: 'pointer',
                        transition: 'background-color 0.3s, color 0.3s',
                        marginTop: '0.5rem',
                        minWidth: '100px', // Set a minimum width for the button
                        maxWidth: '150px', // Set a maximum width for the button
                        whiteSpace: 'nowrap', // Prevent text wrapping
                        overflow: 'hidden', // Hide overflow text
                        textOverflow: 'ellipsis', // Add ellipsis for overflow text
                    }}
                    onClick={() => {
                        if (id === "edu") {
                            navigate('/education', { state: { education: data } });

                        }
                        if (id === "exe") {
                            navigate('/exercise', { state: { exercise: data } });

                        }

                        if (id === 'que') {
                            handleCardClick('questionnaire')
                        }
                    }}
                    onMouseEnter={e => {
                        e.currentTarget.style.backgroundColor = '#015681';
                        e.currentTarget.style.color = 'white';
                    }}
                    onMouseLeave={e => {
                        e.currentTarget.style.backgroundColor = 'transparent';
                        e.currentTarget.style.color = '#015681';
                    }}
                >
                    {title}
                </p>
            </div>
        </div>

    )
}

export default HomeCard;